import { render, staticRenderFns } from "./bo-cart-list.vue?vue&type=template&id=17b62ad8&scoped=true"
import script from "./bo-cart-list.vue?vue&type=script&lang=js"
export * from "./bo-cart-list.vue?vue&type=script&lang=js"
import style0 from "./bo-cart-list.vue?vue&type=style&index=0&id=17b62ad8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b62ad8",
  null
  
)

export default component.exports